import './FAQ.css'
import Accordion from './Accordion'

export default function FAQ() {
  const faqs = [
    {
      question: "What’s included in a CRP package?",
      answer: `Each CRP package includes access to exclusive event updates, premium venues access, special discounts on table and group bookings, and early alerts for theme-based events. It’s designed to keep your team engaged and connected throughout the year.`,
    },
    {
      question: "What benefits are included in the CRP?",
      answer: (
        <>
          <span>CRP members enjoy:</span>
          <ul className="faq-list">
            <li>Regular event updates (music nights, theme nights, festivals)</li>
            <li>Up to 50% discount on table and group bookings</li>
            <li>Access to premium venues</li>
            <li>Theme-based event recommendations and alerts</li>
            <li>Priority booking privileges for corporate groups</li>
          </ul>
        </>
      )
    },
    {
      question: "How is CRP different from a regular group booking?",
      answer: "CRP is an annual program that gives your team ongoing access to discounts and benefits across multiple events and venues throughout the year, rather than a one-time group booking.",
    },
    {
      question: "What types of events are covered under CRP?",
      answer: "CRP covers a range of events, including music nights, DJ nights, theme parties, festivals, and special celebrations. You’ll get personalized alerts and recommendations throughout the year.",
    },
    {
      question: "Is there an annual cost for CRP?",
      answer: "Yes, CRP is available at Rs 99 per employee per year. This gives access to benefits like discounts, premium venue access, and special group rates throughout the year.",
    },
    {
      question: "How do we sign up for CRP?",
      answer: "Simply fill the form or get in touch with our team, confirm the employee count, and we'll help you register. Your CRP benefits will be activated right away.",
    },
  ];


  return (
    <>
      <div className='faq-section'>
        <div className='container'>
          <div className='faq-wrapper'>
            <div className='faq-text'>
              <h1>Frequently Asked Questions</h1>
            </div>
            <div className='faq-content'>
              <Accordion faqs={faqs}/>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
